import { AbstractParser } from "../../parser";
import { ClusterKey } from "src/app/ui/models/domains/pbm/clusters/cluster-key.model";

export class AddNewClusterParser extends AbstractParser<string> {
  parse(payload: any) {
    if (payload.error) {
      return payload.error.Data.ErrorMessage;
    } else if (payload.Value) {
      const clusterKey = new ClusterKey(payload.Value);
      return clusterKey;
    }
  }
}
